import { Navigate, Outlet, useLocation } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { useAuth } from "./auth-context";

export function AuthGuard() {
  const auth = useAuth();
  const location = useLocation();

  if (auth.status === "loading") return <SessionLoadingScreen />;

  if (!auth.isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  return <Outlet />;
}

function SessionLoadingScreen() {
  return (
    <main className="grid min-h-dvh place-items-center bg-background px-6 text-foreground">
      <div role="status" className="flex flex-col items-center text-center">
        <span className="grid size-11 place-items-center rounded-lg border bg-card text-muted-foreground">
          <ShieldCheck className="size-5 animate-pulse" aria-hidden="true" />
        </span>
        <p className="mt-4 text-sm text-muted-foreground">Validando sessão segura…</p>
      </div>
    </main>
  );
}
